import React from 'react'
import { Box, Button, Typography } from '@mui/material'

const DEFAULT_MESSAGE =
  'Free quota for the month has been utilised and you are currently using the basic version with limited features.'

const LimitedAccessBanner = ({
  onUpgrade,
  message = DEFAULT_MESSAGE,
  sx = {},
  buttonSx = {},
  containerSx = {},
}) => {
  return (
    <Box
      sx={{
        bgcolor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: 2,
        p: 2,
        m: 2,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        ...sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1,
          flex: '1 1 300px',
          ...containerSx,
        }}
      >
        <Typography variant='body2' sx={{ color: '#856404' }}>
          <strong>Limited Access:</strong> {message}
        </Typography>
      </Box>
      <Button
        variant='contained'
        size='small'
        onClick={onUpgrade}
        sx={{
          bgcolor: '#ff9800',
          color: 'white',
          '&:hover': { bgcolor: '#f57c00' },
          whiteSpace: 'nowrap',
          flexShrink: 0,
          ml: 'auto',
          ...buttonSx,
        }}
      >
        Upgrade Now
      </Button>
    </Box>
  )
}

export default LimitedAccessBanner
